import apiFinancial from "../config/api_financial";
// import axios from "axios";
import getHeaders from "./getHeaders";

// const apiFinancial = axios.create({
//   baseURL: "http://localhost:8086",
// });

export function getAllDailyLiveCattle(payload) {
  const { groupId, farmId, signal } = payload;

  return apiFinancial.get(
    `/bovexo/${groupId}/farms/${farmId}/data/agro`,
    getHeaders(false, signal)
  );
}

export function getDailyLiveCattleByDate(payload) {
  const { groupId, farmId, searchDate, signal } = payload;

  return apiFinancial.get(
    `/bovexo/${groupId}/farms/${farmId}/data/agro?search_date=${searchDate}`,
    getHeaders(false, signal)
  );
}
